import { hasPaywallExemptTag, isPianoPaywallPageType } from '@/app_lib/types/piano/Paywall';
import type { JsonLdSchema } from 'interfaces/metaDataUtils/jsonLdSchema';
import type { PianoPageConfig } from 'services/Piano/entities/PianoPageConfig';

// All pages are going to be funneled through this, so need to return unmodified schema if no paywall applies
export function addPaywallSchema(schema: string, pageConfig: PianoPageConfig): string {
  try {
    const schemaObj = JSON.parse(schema) as JsonLdSchema;
    const paywallContent = isPaywallContent(pageConfig);

    if (paywallContent) {
      schemaObj.isAccessibleForFree = false;
      schemaObj.hasPart = {
        '@type': 'WebPageElement',
        cssSelector: '.paywall',
        isAccessibleForFree: 'False',
      };
    } else {
      schemaObj.isAccessibleForFree = true;
    }
    const schemaWithPaywall = JSON.stringify(schemaObj);
    return schemaWithPaywall;
  } catch {
    return schema;
  }
}

// This all needs to change to conform to the new config structure
// We should include all logic that determines if content is paywallable
export function isPaywallContent(pageConfig: PianoPageConfig): boolean {
  const { pianoTags, pageType } = pageConfig;
  const isPaywallExempt = hasPaywallExemptTag(pianoTags);
  const isPaywallPageType = isPianoPaywallPageType(pageType);

  return isPaywallPageType && !isPaywallExempt;
}

export function isSubscribePage() {
  return ['/subscribe/', '/paid-subscribe/', '/email-subscribe/'].some((path) =>
    window.location.pathname.includes(path),
  );
}

// export function olderThan12Hours(publishDate: string): boolean {
//   const duration = dateDifferenceInHours(new Date(publishDate), new Date());

//   return duration > 12;
// }

// export function hasExcludedTag(tags: string[]): boolean {
//   const excludedTopics: string[] = [
//     'Always Free',
//     'Battle for Talent',
//     'Breakthrough!',
//     'CFO Daily',
//     'CHRO Daily',
//     'Everyday AI',
//     'Fortune Well',
//     'Leadership Next',
//     'RV Widget Test',
//     'Tech Debate',
//     'Tech Forward',
//     'The Modern Board',
//     'The Path to Zero',
//     'The Trust Factor Newsletter',
//   ];

//   return tags.some((e) => excludedTopics.includes(e));
// }
